import { Component, Injector, OnInit } from '@angular/core';
import { LayoutService } from '../../core/services/layout.service';
import { LoadingService } from '../../shared/services/loading.service';
import { Chart } from 'chart.js';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

Chart.defaults.datasets.bar.maxBarThickness = 73;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    public layoutService: LayoutService,
    private loadingService: LoadingService,
    private injector: Injector
  ) {}

  // hooks
  ngOnInit(): void {
    this.stopLoading();
    this.injector
      .get(Title)
      .setTitle(this.injector.get(TranslateService).currentLang == 'ar' ? 'لوحة التحكم - واعي' : 'Wa3i - Dashboard');
  }

  // privates
  private stopLoading(): void {
    setTimeout(() => {
      this.loadingService.stopLoading();
    }, 100);
  }
}
